import axios from 'axios'
import CreateDistrict from './dto/CreateDistrict'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedDistrictResultRequestDto} from './dto/PagedDistrictResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllDistricts from './dto/GetAllDistricts'
import UpdateDistrict from './dto/UpdateDistrict'
import GetDistrict from './dto/GetDistrict'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/District/Create`
export const URL_DELETE = `${API_URL}/District/Delete`
export const URL_GET = `${API_URL}/District/Get`
export const URL_GET_ALL = `${API_URL}/District/GetPagedAll`
export const URL_UPDATE = `${API_URL}/District/Update`

export function onCreateDistrict(createDistrict: CreateDistrict): Promise<boolean> {
  return axios.post(URL_CREATE, createDistrict)
}

export function onDeleteDistrict(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetDistrict(entityDto: EntityDto): Promise<GetDistrict> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllDistricts(
  pagedFilterAndSortedRequest: PagedDistrictResultRequestDto
): Promise<PagedResultDto<GetAllDistricts>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateDistrict(updateDistrictInput: UpdateDistrict): Promise<boolean> {
  return axios.put(URL_UPDATE, updateDistrictInput)
}
